// import images from "@/assets/images";
import React from "react";
import classNames from "classnames";
import "./index.scss";

interface IGlobalTransitionProps {
  isLoading?: boolean;
}
const GlobalTransition: React.FC<React.PropsWithChildren<IGlobalTransitionProps>> = props => {
  return (
    <div
      className={classNames(
        "absolute flex h-full w-full items-center justify-center bg-[#0b0b0b]",
        props.isLoading ? "" : "loading-out",
      )}
    >
      {/* 使用public下的hy-logo */}
      <img src="./hy-logo.png" className="relative z-10 h-[60px] w-[202px]" />
      <div
        className={classNames(
          "absolute bottom-[0] left-[50%] h-[160vh] w-[160vw] translate-x-[-50%] translate-y-[50%] rounded-[100%] opacity-30",
          props.isLoading ? "loadingbg-infinite" : "",
        )}
        style={{
          background:
            "radial-gradient(68.14% 68.14% at 50% 80%, rgba(255, 215, 54, 0.63) 0%, rgba(255, 215, 54, 0.00) 100%)",
        }}
      ></div>
    </div>
  );
};

export default GlobalTransition;
